import { getBootstrap } from "@/lib/bootstrap";
import type { PageEntry } from "@/types/global";

function normalizePath(path: string): string {
  if (!path) return "/";
  return path.endsWith("/") ? path : `${path}/`;
}

export function useCurrentPage(): PageEntry | null {
  const { page, pages } = getBootstrap();
  const key = normalizePath(page.path);
  return pages[key] ?? pages[page.path] ?? null;
}
